import quickFetch from 'quick-fetch';
import Raven from 'raven-js';
import { httpClient } from '../../http/httpClient';
const regularFetch = () => httpClient.get('chatspot-high-volume/v1/user/info');
export const getChatspotAuthInfo = () => {
  const earlyAuthRequest = quickFetch.getRequestStateByName('chatspotAuth');
  if (earlyAuthRequest) {
    return new Promise((resolve, reject) => {
      earlyAuthRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest('chatspotAuth');
      });
      earlyAuthRequest.onError(() => {
        regularFetch().then(resolve, reject).catch(e => Raven.captureException(e));
        quickFetch.removeEarlyRequest('chatspotAuth');
      });
    });
  } else {
    return regularFetch();
  }
};